import queryString from 'query-string';

export function getLayerDashboardUrlParams() : Url{
    const element = queryString.parse(window.location.search, {});
    const layerToken = element.layerToken as string ?? '';
    const dashboardGroupToken = element.dashboardGroupToken as string ?? '';

    const params: Url = {
        layerToken: layerToken,
        dashboardGroupToken: dashboardGroupToken
    };

    return params;
}

export type Url = {
    layerToken: string;
    dashboardGroupToken: string;
};